// extracted by mini-css-extract-plugin
module.exports = {"sectionWrap":"_2Qcj0","content":"Yn0cp","subText":"_307h9","formWrap":"_1uvLD","successText":"j3AcS"};